import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ef9a196&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef9a196",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ef9a196')) {
      api.createRecord('5ef9a196', component.options)
    } else {
      api.reload('5ef9a196', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5ef9a196&scoped=true", function () {
      api.rerender('5ef9a196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/airTransport/pushConfiguration/index.vue"
export default component.exports